import { CUSTOMER } from './types';
export const getCustomers = payload => {
  return ({
    type: CUSTOMER.GET_CUSTOMERS,
    payload
  });
}
export const getCustomersSuccess = (response) => {
  return ({
    type: CUSTOMER.GET_CUSTOMERS_SUCCESS,
    response,
  })
};

export const getCustomersFailure = (error) => ({
  type: CUSTOMER.GET_CUSTOMERS_FAILURE,
  error
})

export const updateCustomerPagination = (pageNumber = 1) => ({
  type: CUSTOMER.UPDATE_PAGINATION,
  pageNumber
})
/**
 * @param { payload: { activationKey, pagenumber, limit, searchKey } } payload
 */
export const getCustomerUsers = (payload, loadMore) => ({
  type: CUSTOMER.GET_CUSTOMER_USERS,
  payload,
  loadMore,
});

export const getCustomerUsersSuccess = customerUsers => ({
  type: CUSTOMER.GET_CUSTOMER_USERS_SUCCESS,
  customerUsers
});

export const loadMoreCustomerUsersSuccess = customerUsers => ({
  type: CUSTOMER.LOAD_MORE_CUSTOMER_USERS_SUCCESS,
  customerUsers
});

export const getCustomerUsersFailure = error => ({
  type: CUSTOMER.GET_CUSTOMER_USERS_FAILURE,
  error
});

export const getActivationKeyDetails = (activationKey) => ({
  type: CUSTOMER.GET_ACTIVATION_KEY_DETAILS,
  activationKey
})

export const getActivationKeyDetailsSuccess = (activationKeyDetails) => ({
  type: CUSTOMER.GET_ACTIVATION_KEY_DETAILS_SUCCESS,
  activationKeyDetails
})

export const resetCustomerData = () => ({
  type: CUSTOMER.RESET_CUSTOMER_DATA
})
export const getOnlineCustomers = payload => {
  return ({
    type: CUSTOMER.GET_ONLINE_CUSTOMERS,
    payload
  });
}

export const getOnlineCustomersSuccess = onlineCustomers => ({
    type: CUSTOMER.GET_ONLINE_CUSTOMERS_SUCCESS,
    onlineCustomers,
});
export const getOnlineCustomersFailure = (error) => ({
  type: CUSTOMER.GET_ONLINE_CUSTOMERS_FAILURE,
  error
});
